<template>
  <div class="pa-4 text-center">

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn style="background-color:#FF790080; margin-left: -26px; margin-top: -8px;" elevation="0" fab x-small icon
          v-on="on" @click="openDialog">
          <v-icon
            style="color: white; font-size: 23px; position: absolute; top: calc(50% - 8.5px); left: calc(50% - 9.2px);">mdi-lock-reset</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('login.passChange.label.title') }}</span>
    </v-tooltip>
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="600" persistent>

      <v-card class="container justify-content-between align-items-center">
        <button class="close-button" @click="closeDialog">
          <span class="small-x">X</span>
        </button>
        <img src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png" />
        <h2 color="primary">{{ $t('login.passChange.label.title') }}</h2>

        <v-container>
          <v-row dense>

            <v-col cols="12" md="12" sm="6">
              <v-text-field :label="'*'+$t('login.label.currentpassword.title')" :placeholder="$t('login.label.currentpassword.text')" 
                :type="currentPasswordFieldType" required :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'" 
                outlined v-model="user.currentPassword" :rules="currentPasswordRules" color=primary 
                :counter="15" :maxlength="15" @click:append="toggleCurrentPasswordVisibility">
              </v-text-field>
            </v-col>

            <v-col md="12" sm="6">
              <v-text-field :label="'*'+$t('login.label.passwordChange.title')" :placeholder="$t('login.label.passwordChange.text')"
                :type="passwordFieldType" required :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" 
                outlined v-model="user.password" :rules="[...passwordRules]" color=primary 
                :counter="15" :maxlength="15" @click:append="togglePasswordVisibility">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="12" sm="6">
              <v-text-field :label="'*'+$t('login.label.confirmPassword.title')" :placeholder="$t('login.label.confirmPassword.text')"
                :type="confirmationFieldType" required :append-icon="showConfirmation ? 'mdi-eye' : 'mdi-eye-off'" 
                outlined v-model="user.confirmationPassword" :rules="[...confirmPasswordRule]" color=primary 
                :counter="15" :maxlength="15" @click:append="toggleConfirmationVisibility">
              </v-text-field>
              <span
                v-if="user.password && user.confirmationPassword && validatePasswordRepeat(user.confirmationPassword, user.password) !== null && validatePassword(user.password) === null && validatePassword(user.confirmationPassword) === null"
                class="error-message password-match-rule-error" style="text-align: right;">
                  {{ $t('login.label.passwords.invalid') }}
                </span>
            </v-col>
            <v-spacer></v-spacer>

            <v-btn large block rounded color="primary" class="mb-4" style="color: white; border-radius: 50px;"
              @click="changePassword">
              {{ $t('button.change') }}
            </v-btn>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import {
  CHANGEPASSWORDSECURITY_M,
  ACTION_POST_CHANGEPASSWORDSECURITY
} from "@/views/change_password_security/store/types/types.js";

import { mapActions } from 'vuex';
import Swal from "sweetalert2";
import EventBus from '@/utils/event_bus.js';
import i18n from '@/plugins/i18n';
import router from '@/router';

export default {
  name: "FormPasswordValidation",

  data() {
    return {
      dialog: false,
      passwordFieldType: 'password',
      confirmationFieldType: 'password',
      currentPasswordFieldType: 'password',
      showPassword: false,
      showConfirmation: false,
      showCurrentPassword: false,
      passwordsFullyEntered: false,

      user: {
        password: "",
        confirmationPassword: "",
        currentPassword: "",
      },
    }

  },

  computed: {
   
    //Los caracteres especiales permitidos son @, $, !, %, *, ?, . , y &.
    currentPasswordRules() {
      return [
        v => !!v || this.$t('label.password.required'),
        v => v.length >= 8 || this.$t('label.password.minLength'),
        v => /(?=.*[A-Z])(?=.*\d)(?=.*[@#$_&\-+()/*"':;!?])[A-Za-z\d@#$_&\-+()/*"':;!?]{8,}/.test(v) || this.$t('label.password.invalid')
      ];
    },

    passwordRules() {
      return [
        v => !!v || this.$t('label.password.required'),
        v => v.length >= 8 || this.$t('label.password.minLength'),
        v => /(?=.*[A-Z])(?=.*\d)(?=.*[@#$_&\-+()/*"':;!?])[A-Za-z\d@#$_&\-+()/*"':;!?]{8,}/.test(v) || this.$t('label.password.invalid')
      ];
    },

    confirmPasswordRule() {
      return [
        v => !!v || this.$t('label.password.required'),
        v => v.length >= 8 || this.$t('label.password.minLength'),
        v => /(?=.*[A-Z])(?=.*\d)(?=.*[@#$_&\-+()/*"':;!?])[A-Za-z\d@#$_&\-+()/*"':;!?]{8,}/.test(v) || this.$t('label.password.invalid')
      ];
    },
  },

  methods: {
    openDialog() {
      this.dialog = true;
    },

    closeDialog() {
      EventBus.$emit('close-dialog');
      window.location.reload();
    },

    toggleCurrentPasswordVisibility() {
      this.showCurrentPassword = !this.showCurrentPassword;
      this.currentPasswordFieldType = this.showCurrentPassword ? 'text' : 'password';
    },

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
      this.passwordFieldType = this.showPassword ? 'text' : 'password';
    },

    toggleConfirmationVisibility() {
      this.showConfirmation = !this.showConfirmation;
      this.confirmationFieldType = this.showConfirmation ? 'text' : 'password';
    },

    validatePasswordRepeat(passwordRepeat, password) {

      const passwordError = this.validatePassword(password);
      const passwordRepeatError = this.validatePassword(passwordRepeat);

      if (passwordError || passwordRepeatError) {

        return passwordError || passwordRepeatError;
      } else {

        if (passwordRepeat !== password) {
          return this.$t('login.label.passwords.invalid');
        } else {
          return null;
        }
      }
    },
    validatePassword(password) {
      if (!password) return this.$t('label.password.required');
      if (password.length < 8) return this.$t('label.password.minLength');
      if (/(?=.*[A-Z])(?=.*\d)(?=.*[@#$_&\-+()/*"':;!?])[A-Za-z\d@#$_&\-+()/*"':;!?]{8,}/.test(password)) return this.$t('label.password.invalid');
      return null;
    },

    ...mapActions({
      postChangePasswordSecurity: `${CHANGEPASSWORDSECURITY_M}${ACTION_POST_CHANGEPASSWORDSECURITY}`,
    }),

    async changePassword() {
      const errors = this.validateForm();

      if (Object.keys(errors).length > 0) {
        const errorMessages = Object.values(errors).join('<br>');
        return Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.plural.title'),
          html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
          confirmButtonColor: '#6E17A5'
        });
      } else {
        try {
          await this.postChangePasswordSecurity(this.user);
          this.dialog = false;
          sessionStorage.clear();
          router.push('/login')
        } catch (error) {
          console.error(i18n.t('label.invalid.title'), error);
        }
      }
    },


    validateForm() {
      const PASSWORD_REGEX = /(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%&/*(),.?":;{}|<>=+\-^])[A-Za-z\d!@#$%&/*(),.?":;{}|<>=+\-^]{8,}/;

      const errors = {};

      if (!this.user.currentPassword || this.user.currentPassword.trim().length < 8 || !PASSWORD_REGEX.test(this.user.currentPassword)) {
        errors.currentPassword = this.$t('login.label.currentpassword.title');
      }

      if (!this.user.password || this.user.password.trim().length < 8 || !PASSWORD_REGEX.test(this.user.password)) {
        errors.password = this.$t('login.label.passwordChange.title');
      }

      if (!this.user.confirmationPassword || this.user.confirmationPassword.trim().length < 8 || !PASSWORD_REGEX.test(this.user.confirmationPassword)) {
        errors.confirmationPassword = this.$t('login.label.confirmPassword.title');
      } else if (this.user.confirmationPassword !== this.user.password) {
        errors.confirmationPassword = this.$t('login.label.passwords.invalid');
      }

      return errors;
    },
  }
}
</script>

<style lang="css" scoped>
body {
  font-family: 'Nunito Sans', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Amsi Pro', sans-serif;
}

img {
  width: 30vh;
}

.password-match-rule-error {
  color: red;
  font-size: 12px;
}

.small-x {
  font-size: smaller;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3vh;
  color: #6E17A5;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

@media screen and (max-width: 900px) {
  .row {
    padding-top: 0vh;
  }
}
</style>